import { useState, useEffect } from 'react';
import styles from './index.module.sass';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import qs from 'query-string';
import repo from 'service/repository';
import amplitude from 'service/amplitude';
import NotFound from 'pages/not-found';
import gaBridge from 'bridge/ga-bridge';
import Button from 'components/button';
import Logo from 'components/logo';
import LoadingDialog from 'components/loading-dialog';
import Header from 'components/header';
import CoinGround from 'components/coin-ground';
import Contents from 'components/contents';
import Main from 'components/main';
import Title from 'components/title';
import SubTitle from 'components/sub-title';
import Wrapper from 'components/wrapper';
import Envolope from 'components/envolope';
import FormInput from 'components/form-input';
import ShareDialog from 'components/share-dialog';
import ErrorDialog from 'components/error-dialog';

import { useAppContext } from 'use-app';
import { PATH, VALIDATE_STATUS } from 'config';
import validation from 'service/validation';

const SERIAL_CODE = 'serialCode';
const PLATE_NUMBER = 'plateNumber';

const Coupon = () => {
  const { couponId } = useParams();
  const history = useHistory();
  const [init, setInit] = useState(false);
  const [coupon, setCoupon] = useState();
  const [source, setSource] = useState('');
  const [couponIsActive, setCouponIsActive] = useState();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const { isContinued, userLicensePlate, userEmail, userMobile, setUserLicensePlate } = useAppContext();

  //   verify page state
  const [payload, setPayload] = useState({
    [SERIAL_CODE]: '',
    [PLATE_NUMBER]: '',
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [errorCode, setErrorCode] = useState('');
  const [errorDialogShow, setErrorDialogShow] = useState(false);
  const [valid, setValid] = useState({
    [SERIAL_CODE]: VALIDATE_STATUS.INIT,
    [PLATE_NUMBER]: VALIDATE_STATUS.INIT,
  });
  const [shareDialogShow, setShareDialogShow] = useState(false);

  // 抓取 coupon
  useEffect(() => {
    repo
      .fetchCoupons(couponId)
      .then(coupon => {
        setCoupon(coupon);
        setCouponIsActive(() => moment().isBetween(moment(coupon.start_at), moment(coupon.end_at)));
        document.title = coupon.attributes.campaign;
        amplitude.couponPageview(coupon, source);
        gaBridge.logEvent('coupon', 'pageview', coupon.attributes.campaign);
        setPayload(prev => ({ ...prev, [SERIAL_CODE]: coupon.attributes.default }));
      })
      .finally(() => {
        setInit(true);
        setLoading(false);
      });
  }, []); //eslint-disable-line

  // 若為繼續領取優惠，則自動填入車牌
  useEffect(() => {
    if (!isContinued) return;
    setPayload(prev => ({ ...prev, [PLATE_NUMBER]: userLicensePlate }));
    setValid(prev => ({ ...prev, [PLATE_NUMBER]: VALIDATE_STATUS.VALID }));
  }, [isContinued, userLicensePlate]);

  useEffect(() => {
    // 偵測是否為從其他頁面跳轉過來，並有攜帶 source 參數
    try {
      const referrer = document.referrer;
      const params = qs.parse(new URL(referrer).search.replace('?', ''));
      setSource(params.source);
    } catch (e) {
      console.log('referrer url params source not found');
    }
  }, []);

  const formData = [
    {
      id: SERIAL_CODE,
      placeHolder: '輸入專屬優惠序號',
      maxLength: 20,

      onChange: value => {
        setPayload(prev => ({ ...prev, [SERIAL_CODE]: value }));
        if (value.length === 0) {
          setValid(prev => ({ ...prev, [SERIAL_CODE]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [SERIAL_CODE]: '必填' }));
        } else {
          setValid(prev => ({ ...prev, [SERIAL_CODE]: VALIDATE_STATUS.VALID }));
        }
      },
      onFocus: () => {
        amplitude.couponSerialCodeOnClick(coupon, source);
      },
    },
    {
      id: PLATE_NUMBER,
      placeHolder: '輸入使用優惠的指定車牌',
      maxLength: 8,

      onChange: value => {
        setPayload(prev => ({ ...prev, [PLATE_NUMBER]: value }));
        if (value.length === 0) {
          setValid(prev => ({ ...prev, [PLATE_NUMBER]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [PLATE_NUMBER]: '必填' }));
          return;
        }
        let isPlateNumber = validation.isPlateNumber(value);
        if (isPlateNumber) {
          setValid(prev => ({ ...prev, [PLATE_NUMBER]: VALIDATE_STATUS.VALID }));
        } else {
          setValid(prev => ({ ...prev, [PLATE_NUMBER]: VALIDATE_STATUS.INVALID }));
          setErrorMessage(prev => ({ ...prev, [PLATE_NUMBER]: '車牌格式錯誤' }));
        }
      },
      onFocus: () => {
        amplitude.couponPlateNumberOnClick(coupon, source);
      },
    },
  ];

  const onVerify = () => {
    const { plateNumber, serialCode } = payload;
    setUserLicensePlate(plateNumber);
    setLoading(true);

    // 已兌換過一次，繼續兌換不同的序號
    if (isContinued) {
      gaBridge.logEvent('coupon_continue_get_rewards', 'click_next', coupon.attributes.campaign);
      return repo
        .redeemCoupon(couponId, serialCode, plateNumber, userEmail, userMobile)
        .then(() => {
          setShareDialogShow(true);
          setPayload(prev => ({ ...prev, [SERIAL_CODE]: '' }));
          amplitude.continueOnClick('success', userMobile, userEmail, coupon, source);
        })
        .catch(error => {
          gaBridge.logEvent('coupon_continue_get_rewards', 'error', coupon.attributes.campaign);
          const errorCode = error.response.data.error.code;
          setErrorDialogShow(true);
          setErrorCode(errorCode);
          amplitude.continueOnClick('failure', userMobile, userEmail, coupon, source, errorCode);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    gaBridge.logEvent('coupon_verify_license_plate', 'click_next', coupon.attributes.campaign);
    repo
      .validateCoupon(coupon.id, serialCode, plateNumber)
      .then(() => {
        const data = {
          plateNumber,
          serialCode,
          source: source,
          coupon: coupon,
        };
        setLoading(false);
        history.push({ pathname: `${PATH.GET_REWARDS}/${coupon.id}`, state: data });
        amplitude.verifyOnClick('success', plateNumber, serialCode, coupon, source);
      })
      .catch(error => {
        const errorCode = error.response.data.error.code;
        setErrorDialogShow(true);
        setErrorCode(errorCode);
        setLoading(false);
        gaBridge.logEvent('coupon_verify_license_plate', 'error', coupon.attributes.campaign);
        amplitude.verifyOnClick('failure', plateNumber, serialCode, coupon, source, errorCode);
      });
  };

  const buttonText = coupon => {
    if (couponIsActive) return '登錄序號拿優惠 ▸';
    if (moment().isBefore(coupon.startAt)) {
      return '本次活動尚未開始！';
    } else {
      return '本次活動已結束';
    }
  };

  const CouponContent = () => {
    if (!init) return <></>;
    if (!coupon) {
      return <NotFound />;
    }

    return (
      <div>
        <ShareDialog
          show={shareDialogShow}
          coupon={coupon}
          source={source}
          mobile={userMobile}
          email={userEmail}
          onClose={() => {
            setShareDialogShow(false);
          }}
        />
        <ErrorDialog
          show={errorDialogShow}
          couponCode={payload[SERIAL_CODE]}
          plateNumberAlreadyExistsErrorMessage={coupon.attributes.plate_number_already_exists_error_message}
          errorCode={errorCode}
          plateNumber={userLicensePlate}
          mobile={userMobile}
          onClose={() => setErrorDialogShow(false)}
        />
        <CoinGround />
        <Wrapper show={show}>
          <Header>
            <Title>
              <img src={coupon.attributes.logo} alt="logo" />
            </Title>
          </Header>
          <Main>
            <Envolope
              onLoad={() => {
                setShow(true);
              }}
            />
            <SubTitle>
              <div dangerouslySetInnerHTML={{ __html: coupon.attributes.sub_title }} />
            </SubTitle>
            <Contents>
              <form>
                {formData.map(data => {
                  return (
                    <FormInput
                      key={data.id}
                      value={payload[data.id]}
                      status={valid[data.id]}
                      errorMessage={errorMessage[data.id]}
                      id={data.id}
                      placeHolder={data.placeHolder}
                      maxLength={data.maxLength}
                      onChange={data.onChange}
                      onFocus={data.onFocus}
                    />
                  );
                })}
              </form>

              <Button
                disabled={!(couponIsActive && valid[SERIAL_CODE] === 'valid' && valid[PLATE_NUMBER] === 'valid')}
                onClick={onVerify}
              >
                {buttonText(coupon)}
              </Button>
            </Contents>
            <Logo icon={coupon.attributes.partner_icon} />
          </Main>
          <div className={styles.footer}>
            <div className={styles.notice}>
              <div dangerouslySetInnerHTML={{ __html: coupon.attributes.index_promotion_notice_title }}></div>
              <div>
                <ul>
                  {coupon.attributes.index_promotion_notice_content.split('\n').map((list, key) => (
                    <li dangerouslySetInnerHTML={{ __html: list }} key={key} />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
    );
  };

  return (
    <>
      <LoadingDialog show={loading} />
      {CouponContent()}
    </>
  );
};

export default Coupon;
